export const MAX_BILL_COUNT = 2_000;
export const MAX_COIN_COUNT = 300;
